import { render, staticRenderFns } from "./ElectricityHistoricalDataModal.vue?vue&type=template&id=38a08771"
import script from "./ElectricityHistoricalDataModal.vue?vue&type=script&lang=js"
export * from "./ElectricityHistoricalDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports